<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
<div *ngIf="companyId">



  <ng-container *ngIf="company && company.orderMethod == 2">
    <div style="height: 100px;"></div>
    <div *ngIf="showPlayStoreIcon || showAppStoreIcon || (selectedProduct && (selectedProduct.showPlayStoreIcon || selectedProduct.showAppStoreIcon))" style="text-align: center; padding: 30px;">
      <div style="display: inline-block; margin: 20px 10px;"  *ngIf="showAppStoreIcon || (selectedProduct && selectedProduct.showAppStoreIcon)">
        <a [href]="selectedProduct?.appStoreLink || appStoreLink" target="_blank">
          <img alt="apple app store link" src="assets/img/app-store-badge.png" height="50" />
        </a>
      </div>
      <div style="display: inline-block; margin: 20px 10px;"  *ngIf="showPlayStoreIcon || (selectedProduct && selectedProduct.showPlayStoreIcon)">
        <a [href]="selectedProduct?.playStoreLink || playStoreLink" target="_blank">
          <img alt="google play store link" src="assets/img/google-play-badge.png" height="50" />
        </a>
      </div>

      <ng-container *ngIf="company && company.id == 1">
        <div>
          <img alt="Bestelle jetzt deine king+ Karte" src="assets/img/king_order_link_image.png" style="width: 80%; max-width: 500px; min-width: 200px;" />
        </div>
      </ng-container>

    </div>

  </ng-container>





  <ng-container *ngIf="company && company.orderMethod == 1">
    <app-header></app-header>

    <form *ngIf="orderForm" [formGroup]="orderForm">
      <mat-horizontal-stepper [linear]="true" (selectionChange)="onStepChange($event)" #stepper class="order-assistant-stepper">
        <mat-step formGroupName="product" [stepControl]="orderForm.controls.product" [editable]="!orderFormDisabled">
          <ng-template matStepLabel><div *ngIf="stepper.selectedIndex == 0">{{"ORDER.TIME_4_MIN_START" | translate}}</div></ng-template>

          <mat-card class="step-card-2 mb-1">
            <mat-card-content>
              <mat-progress-bar mode="determinate" value="0"></mat-progress-bar>
              <div style="height:3px;"></div>
              <div class="text-center w-100">{{"ORDER.TIME_4_MIN_START" | translate}}</div>
              <div style="height:10px;"></div>
            </mat-card-content>
          </mat-card>

          <mat-card class="step-card">
            <mat-card-header>
              <mat-card-title>
                {{"ORDER.PRODUCT.TITLE" | translate }}
              </mat-card-title>
              <mat-card-subtitle>{{"ORDER.PRODUCT.SUBTITLE" | translate}}</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
              <app-card-selector [products]="productsData" [companyId]="companyId" formControlName="productId" required></app-card-selector>

              <hr />



            </mat-card-content>
            <mat-card-actions align="end">
                <button mat-raised-button matStepperPrevious
                  [disabled]="products && products.products && products.products.length == 0"
                  type="button">{{"BUTTON.PREVIOUS" | translate}}
                </button>
              <div fxFlex></div>
                <button mat-raised-button matStepperNext color="primary"
                  [disabled]="products && products.products && products.products.length == 0"
                  type="button">{{"BUTTON.NEXT" | translate}}
                </button>
            </mat-card-actions>
          </mat-card>


          <div *ngIf="showPlayStoreIcon || showAppStoreIcon || (selectedProduct && (selectedProduct.showPlayStoreIcon || selectedProduct.showAppStoreIcon))" style="text-align: center; padding: 30px;">
            <div style="display: inline-block; margin: 20px 10px;"  *ngIf="showAppStoreIcon || (selectedProduct && selectedProduct.showAppStoreIcon)">
              <a [href]="selectedProduct?.appStoreLink || appStoreLink" target="_blank">
                <img alt="apple app store link" src="assets/img/app-store-badge.png" height="50" />
              </a>
            </div>
            <div style="display: inline-block; margin: 20px 10px;"  *ngIf="showPlayStoreIcon || (selectedProduct && selectedProduct.showPlayStoreIcon)">
              <a [href]="selectedProduct?.playStoreLink || playStoreLink" target="_blank">
                <img alt="google play store link" src="assets/img/google-play-badge.png" height="50" />
              </a>
            </div>
          </div>


        </mat-step>

        <!-- NAME AND EMAIL -->
        <mat-step formGroupName="name" [stepControl]="orderForm.controls.name" [editable]="!orderFormDisabled"

                  [completed]="step1completed"
        >
          <ng-template matStepLabel><div *ngIf="stepper.selectedIndex == 1">{{"ORDER.TIME_4_MIN" | translate}}</div></ng-template>

          <mat-card class="step-card-2 mb-1">
            <mat-card-content>
              <mat-progress-bar mode="determinate" value="2"></mat-progress-bar>
              <div style="height:3px;"></div>
              <div class="text-center w-100">{{"ORDER.TIME_4_MIN" | translate}}</div>
              <div style="height:10px;"></div>
            </mat-card-content>
          </mat-card>

          <mat-card class="step-card">
            <mat-card-header>
              <mat-card-title>{{"ORDER.FULL_NAME.TITLE" | translate}}</mat-card-title>
              <mat-card-subtitle>{{"ORDER.FULL_NAME.SUBTITLE" | translate}}</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
              <br />
              <mat-checkbox class="thin-checkbox" formControlName="isCompany" [hidden]="companyId != 1 && companyId != 2">
                {{'ORDER.FULL_NAME.FORM.IS_COMPANY' | translate}}
              </mat-checkbox>
              <div [hidden]="!showCompanyInput">
                <mat-form-field>
                  <input matInput appTitleCase [placeholder]="'ORDER.FULL_NAME.FORM.COMPANY' | translate" formControlName="companyName"
                         min="2" max="50">
                  <mat-error>

                  </mat-error>
                </mat-form-field>
              </div>

              <br />
              <mat-form-field>
                <mat-select [placeholder]="'ORDER.FULL_NAME.FORM.TITLE' | translate" formControlName="title" required>
                  <mat-option *ngFor="let title of titles" [value]="title">{{title}}</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field>
                <input matInput appTitleCase [placeholder]="'ORDER.FULL_NAME.FORM.FIRST_NAME' | translate" formControlName="firstName"
                  minlength="2" maxlength="50" pattern="^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s-]*)$">
                <mat-error>
                  {{'ORDER.FULL_NAME.FORM.FIRST_AND_LAST_NAME_LENGTH_EXCEEDED' | translate}}
                </mat-error>
              </mat-form-field>
              <mat-form-field>
                <input matInput appTitleCase [placeholder]="'ORDER.FULL_NAME.FORM.LAST_NAME' | translate" formControlName="lastName"
                  minlength="2" maxlength="50" pattern="^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s-]*)$">
                <mat-error>
                  {{'ORDER.FULL_NAME.FORM.FIRST_AND_LAST_NAME_LENGTH_EXCEEDED' | translate}}
                </mat-error>
              </mat-form-field>

              <br /><br />
              <mat-form-field>
                <input matInput [placeholder]="'ORDER.EMAIL_ADDRESS.FORM.EMAIL' | translate" formControlName="email"
                       required minlength="7" maxlength="70"
                       >

                <mat-error>
                  {{'ORDER.EMAIL_ADDRESS.FORM.EMAIL_NOT_VALID_OR_IN_USE' | translate}}
                </mat-error>
              </mat-form-field>
              <div *ngIf="isCheckingEmail">
                {{'ORDER.EMAIL_ADDRESS.FORM.CHECKING_EMAIL' | translate}}
              </div>
              <mat-form-field>
                <input matInput [placeholder]="'ORDER.EMAIL_ADDRESS.FORM.CONFIRM_EMAIL' | translate"
                       formControlName="confirmEmail" maxlength="70" required>
              </mat-form-field>


              <!--<mat-checkbox class="thin-checkbox" formControlName="wantCardName"
                (change)="$event.checked? orderForm.get('name').get('cardName').enable():orderForm.get('name').get('cardName').disable()">
                {{'ORDER.FULL_NAME.FORM.WANT_CARD_NAME' | translate}}
              </mat-checkbox>-->

              <mat-form-field *ngIf="this.orderForm.value.name.wantCardName">
                <input matInput appTitleCase [placeholder]="'ORDER.FULL_NAME.FORM.CARD_NAME' | translate" formControlName="cardName"
                  pattern="[a-zA-Z'-\s]*" maxlength="50" type="text">
                <mat-error>
                  {{'ORDER.FULL_NAME.FORM.CARD_NAME_LENGTH_EXCEEDED' | translate}}
                </mat-error>
              </mat-form-field>
              <div [hidden]="companyId != 1">
                <mat-checkbox class="thin-checkbox" formControlName="wantTotalCardInfos">
                  {{'ORDER.FULL_NAME.FORM.WANT_TOTALCARD_INFOS' | translate}}
                </mat-checkbox>
              </div>
              <br><br>
              <mat-checkbox class="thin-checkbox" formControlName="privacyPolicy" [(ngModel)]="isConfirmed"
                            [checked]="isConfirmed" required style="margin-right: 8px;">
                <span>
                  {{'ORDER.FULL_NAME.FORM.CHECKBOXES.BEFORE_PRIVACY' | translate}}
                  <a target="_blank"
                    [routerLink]="'../../documents/' + links[0]">{{docsNames.labels.license_agreement | translate}}</a>,
                  <a target="_blank"
                    [routerLink]="'../../documents/' + links[1]">{{docsNames.labels.terms_and_services | translate}}</a>
                  {{'ORDER.FULL_NAME.FORM.CHECKBOXES.AND' | translate}}
                  <a target="_blank"
                     [routerLink]="'../../documents/' + links[3]">{{docsNames.labels.cashback_conditions | translate}}</a>.
                </span>
              </mat-checkbox>
              <br>



              <br>

              <mat-checkbox class="thin-checkbox" formControlName="wantNews">
                {{'ORDER.FULL_NAME.FORM.CHECKBOXES.RECEIVE_UPDATES' | translate}}.
              </mat-checkbox>

            </mat-card-content>
            <mat-card-actions align="end">
              <button mat-raised-button matStepperPrevious type="button">{{"BUTTON.PREVIOUS" | translate}}</button>
              <div fxFlex></div>
              <button mat-raised-button [disabled]="!isConfirmed || orderForm.get('name').status==='INVALID'"
                matStepperNext color="primary" type="button">{{"BUTTON.NEXT" | translate}}</button>
            </mat-card-actions>
          </mat-card>
        </mat-step>


        <!-- ADDRESS, DOB, NATIONALITY -->

        <mat-step formGroupName="location" [stepControl]="orderForm.controls.location" [editable]="!orderFormDisabled"

                  [completed]="step2completed"
        >
          <ng-template matStepLabel><div *ngIf="stepper.selectedIndex == 2">{{"ORDER.TIME_3_MIN" | translate}}</div></ng-template>

          <mat-card class="step-card-2 mb-1">
            <mat-card-content>
              <mat-progress-bar mode="determinate" value="25"></mat-progress-bar>
              <div style="height:3px;"></div>
              <div class="text-center w-100">{{"ORDER.TIME_3_MIN" | translate}}</div>
              <div style="height:10px;"></div>
            </mat-card-content>
          </mat-card>

          <mat-card class="step-card">
            <mat-card-header>
              <!--
              <mat-card-title>{{"ORDER.ADDRESS.TITLE" | translate}}</mat-card-title>
              <mat-card-subtitle>{{"ORDER.ADDRESS.SUBTITLE" | translate}}</mat-card-subtitle>
              -->
            </mat-card-header>
            <mat-card-content>
              <mat-card-title style="color: black;">{{ 'ORDER.DOB.TITLE' | translate }}</mat-card-title>

              <app-date-edit [placeholder]="'ORDER.DOB.FORM.DOB' | translate" formControlName="dob" required
                             [max]="maxDob" [min]="minDob"></app-date-edit>
              <mat-error *ngIf="orderForm.get('location').get('dob').hasError('required')">
                {{'ORDER.FULL_NAME.FORM.DOB_IVALID' | translate}}
              </mat-error>


              <br/><br/><br/>
              <mat-card-title>{{ 'ORDER.NATIONALITY.TITLE' | translate }}</mat-card-title>
              <mat-form-field>
                <mat-select [placeholder]="'ORDER.NATIONALITY.FORM.NATIONALITY' | translate" formControlName="nationality"
                            required>
                  <mat-option *ngFor="let country of nationalities" [value]="country.name">
                    {{_currentLanguage==='de' ? country.nameDE : country.name }}</mat-option>
                </mat-select>
              </mat-form-field>

              <br/><br/><br/>
              <mat-card-title style="color: black;">{{"ORDER.ADDRESS.TITLE" | translate}}</mat-card-title>
              <mat-form-field>
                <input matInput appAddressCase [placeholder]="'ORDER.ADDRESS.FORM.ADDRESS' | translate" formControlName="address"
                  maxlength="50" required>
              </mat-form-field>
              <mat-form-field>
                <input matInput [placeholder]="'ORDER.ADDRESS.FORM.BUILDING' | translate" formControlName="building"
                  required>
              </mat-form-field>
              <mat-form-field>
                <input matInput [placeholder]="'ORDER.ADDRESS.FORM.ZIP' | translate" formControlName="zipCode"
                  maxlength="50" required>
              </mat-form-field>
              <mat-form-field>
                <input appAddressCase matInput [placeholder]="'ORDER.ADDRESS.FORM.CITY' | translate" formControlName="city"
                  maxlength="50" required>
              </mat-form-field>
              <mat-form-field>
                <mat-select [placeholder]="'ORDER.ADDRESS.FORM.COUNTRY' | translate" formControlName="countryIsoCode"
                  required>
                  <mat-option *ngFor="let country of countries" [value]="country.isoCode">
                    {{_currentLanguage==='de' ? country.nameDE : country.name }}</mat-option>
                </mat-select>
              </mat-form-field>

            </mat-card-content>
            <mat-card-actions align="end">
              <button mat-raised-button matStepperPrevious type="button">{{"BUTTON.PREVIOUS" | translate}}</button>
              <div fxFlex></div>
              <button mat-raised-button matStepperNext color="primary"
                type="button">{{"BUTTON.NEXT" | translate}}</button>
            </mat-card-actions>
          </mat-card>
        </mat-step>

        <mat-step formGroupName="phone" [stepControl]="orderForm.controls.phone" [editable]="!orderFormDisabled"

                  [completed]="step3completed"
        >
          <ng-template matStepLabel><div *ngIf="stepper.selectedIndex == 3">{{"ORDER.TIME_2_5_MIN" | translate}}</div></ng-template>

          <mat-card class="step-card-2 mb-1">
            <mat-card-content>
              <mat-progress-bar mode="determinate" value="38"></mat-progress-bar>
              <div style="height:3px;"></div>
              <div class="text-center w-100">{{"ORDER.TIME_2_5_MIN" | translate}}</div>
              <div style="height:10px;"></div>
            </mat-card-content>
          </mat-card>

          <mat-card class="step-card">
            <mat-card-header>
              <mat-card-title>{{"ORDER.MOBILE.TITLE" | translate}}</mat-card-title>
              <mat-card-subtitle>{{"ORDER.MOBILE.SUBTITLE" | translate}}</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
              <app-phone-input #phoneInput formControlName="phone" [phoneVerified]="isPhoneVerified" [productId]="this.selectedProductId" (nextStep)="nextStep(stepper)" minlength="9" maxlength="15"
                required></app-phone-input>
            </mat-card-content>
            <mat-card-actions align="end">
              <button mat-raised-button matStepperPrevious type="button">{{"BUTTON.PREVIOUS" | translate}}</button>
              <div fxFlex></div>
              <!--<button mat-raised-button matStepperNext color="primary" [disabled]="orderForm.controls.phone.invalid"
                type="button">{{"BUTTON.NEXT" | translate}}</button>-->
            </mat-card-actions>
          </mat-card>
        </mat-step>
        <mat-step formGroupName="paymentType" [stepControl]="orderForm.controls.paymentType"
          [editable]="!orderFormDisabled"
          [completed]="step4completed"

        >
          <ng-template matStepLabel><div *ngIf="stepper.selectedIndex == 4">{{"ORDER.TIME_2_MIN" | translate}}</div></ng-template>

          <mat-card class="step-card-2 mb-1">
            <mat-card-content>
              <mat-progress-bar mode="determinate" value="50"></mat-progress-bar>
              <div style="height:3px;"></div>
              <div class="text-center w-100">{{"ORDER.TIME_2_MIN" | translate}}</div>
              <div style="height:10px;"></div>
            </mat-card-content>
          </mat-card>

          <mat-card class="step-card">
            <mat-card-header>
              <mat-card-title>{{"ORDER.SUMMARY.TITLE" | translate}}</mat-card-title>
              <mat-card-subtitle></mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>

              <ng-container *ngIf="selectedProduct">
                <div style="margin: 10px auto;text-align: center;">
                  <img height="80" class="card-img" [src]="selectedProduct.logoUrl" />
                </div>
              </ng-container>


              <app-order-summary *ngIf="this.partialOrder" [product]="this.selectedProduct" [orderForm]="partialOrder"></app-order-summary>

              <div style="height: 10px; padding: 5px; text-align: right">
                <button style="border-radius: 5px; padding: 4px; border: 2px solid #b6c700; background-color: white; color: black;" (click)="correctDataClicked()">{{"GENERIC.CORRECT_DATA" | translate}}</button>
              </div>

              <div style="height: 20px;"></div>

              <ng-container *ngIf="orderPrice > 0">

                <ng-container *ngIf="allowedPaymentMethods2.voucher">
                  <mat-card-header>
                    <mat-card-title>{{"ORDER.PAYMENT.TITLE" | translate}}</mat-card-title>
                    <mat-card-subtitle>{{"ORDER.PAYMENT.SUBTITLE" | translate}}</mat-card-subtitle>
                  </mat-card-header>

                </ng-container>

                <app-payment-type-selector [disabled]="orderForm.invalid || orderFormDisabled" [selectedProduct]="selectedProduct" [hidden]="!allowedPaymentMethods2.voucher" [wantCardName]="orderForm.value.name.wantCardName" [productId]="orderForm.value.product.productId"
                                            [allowedPaymentMethods]="allowedPaymentMethods2" formControlName="paymentType2">
                </app-payment-type-selector>

                <div style="height: 20px;"></div>
                <div *ngIf="showPaymentType2">
                  {{"ORDER.PAYMENT.FORM.TO_PAY" | translate}} € {{ voucherToPay }}
                </div>
                <div style="height: 20px;"></div>

                <div [hidden]="this.voucherToPay != null && this.voucherToPay <= 0">
                  <mat-card-header>
                    <mat-card-title>{{"ORDER.PAYMENT.TITLE" | translate}}</mat-card-title>
                    <mat-card-subtitle>{{"ORDER.PAYMENT.SUBTITLE" | translate}}</mat-card-subtitle>
                  </mat-card-header>

                  <app-payment-type-selector [disabled]="orderForm.invalid || orderFormDisabled" [selectedProduct]="selectedProduct" [wantCardName]="orderForm.value.name.wantCardName" [productId]="orderForm.value.product.productId"
                    [allowedPaymentMethods]="allowedPaymentMethods" formControlName="paymentType" required>
                  </app-payment-type-selector>
                </div>
              </ng-container>

              <div *ngIf="orderFormDisabled" style="width: 100%; text-align: center; margin-top: 20px; margin-bottom: 20px;">
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                <div style="margin-top: 5px;">{{"GENERIC.WAIT" | translate}}</div>
              </div>

            </mat-card-content>
            <mat-card-actions align="end">
              <button mat-raised-button matStepperPrevious type="button">{{"BUTTON.PREVIOUS" | translate}}</button>
              <div fxFlex></div>
              <button mat-raised-button id="button-buy-for-amount" color="primary" (click)="createOrder()" *ngIf="!orderFormDisabled && this.selectedProduct"
                [disabled]="orderForm.invalid || orderForm.disabled || orderFormDisabled">{{"BUTTON.BUY_FOR_AMOUNT" | translate : {amount:this.selectedProduct.issuingFee + this.selectedProduct.annualFee} }}</button>
              <button mat-raised-button id="button-summary-submit" color="primary" *ngIf="orderFormDisabled"
                      disabled="true">{{"BUTTON.SUBMIT" | translate}}</button>
            </mat-card-actions>
          </mat-card>
        </mat-step>



        <mat-step [editable]="!orderFormDisabled" [completed]="step5completed">
          <ng-template matStepLabel><div *ngIf="stepper.selectedIndex == 5">{{"ORDER.TIME_0_END" | translate}}</div></ng-template>

          <mat-card class="step-card-2 mb-1">
            <mat-card-content>
              <mat-progress-bar mode="determinate" value="100"></mat-progress-bar>
              <div style="height:3px;"></div>
              <div class="text-center w-100">{{"ORDER.TIME_0_END" | translate}}</div>
              <div style="height:10px;"></div>
            </mat-card-content>
          </mat-card>

          <mat-card class="step-card">
            <mat-card-header>
              <mat-card-title style="text-align: center">
                {{"ORDER.SUMMARY.SUCCESS.TITLE" | translate : { firstname:summaryPageUserAddressing?.firstName } }}
              </mat-card-title>
            </mat-card-header>
            <mat-card-content class="margin-left-16px">
            <!--  <div>
                <div [innerHTML]="'ORDER.SUMMARY.SUCCESS.TEXT' | translate : { firstname: summaryPageUserAddressing?.firstName }"></div>
              </div>

              <div *ngIf="showWebIdInfo" style="margin-top: 30px;">
                {{"ORDER.SUMMARY.WEBID.INFOTEXT" | translate}}
              </div>
  -->

              <div *ngIf="showWebIdInfo" style="min-height: 200px; margin-top: 50px; margin-bottom: 80px; text-align: center">
                <button mat-raised-button color="primary" style="font-size: 1.2em; padding: 10px 25px; font-weight: bold"
                        (click)="redirectToWebId()"
                        type="button">{{"ORDER.SUMMARY.WEBID.BUTTONTEXT" | translate}}
                </button>


              </div>

            </mat-card-content>

            <mat-card-actions align="end">

            </mat-card-actions>
          </mat-card>
        </mat-step>
      </mat-horizontal-stepper>
    </form>
  </ng-container>
</div>
